export const environment = {
  clientId: 'farabi-spa'
};
